import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import MemberListData from './MemberListData';
import MemberListView from './View';

const MemberListEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <MemberListView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <MemberListData
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default MemberListEdit;
